// ============================================
// Khoảng ngày cho bộ lọc nhanh "Today / This week / This month".
//
// Bug #32: hai dropdown ở "Overall Information" và "Top Categories" chỉ giữ
// state cục bộ trong component, không ai đọc tới — chọn gì biểu đồ cũng y hệt.
// File này là chỗ DUY NHẤT quy đổi lựa chọn đó ra `start_date`/`end_date` để
// truyền xuống hook gọi API, tránh mỗi panel tự tính một kiểu.
// ============================================

/** Giá trị của dropdown. Dùng mã cố định, KHÔNG dùng nhãn đã dịch. */
export type QuickPeriod = 'today' | 'week' | 'month';

export interface QuickPeriodRange {
  start_date: string;
  end_date: string;
}

export const QUICK_PERIODS: readonly QuickPeriod[] = ['today', 'week', 'month'] as const;

/** Nhãn i18n tương ứng từng mã — panel nào cũng dùng đúng bộ nhãn này. */
export const QUICK_PERIOD_LABEL_KEYS: Record<QuickPeriod, string> = {
  today: 'today',
  week: 'thisWeek',
  month: 'thisMonth',
};

/** Ngày theo GIỜ ĐỊA PHƯƠNG (không dùng toISOString — nó quy về UTC và lệch ngày). */
function toLocalIsoDate(value: Date): string {
  const year = value.getFullYear();
  const month = `${value.getMonth() + 1}`.padStart(2, '0');
  const day = `${value.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function isQuickPeriod(value: unknown): value is QuickPeriod {
  return value === 'today' || value === 'week' || value === 'month';
}

/**
 * Quy đổi lựa chọn thành khoảng ngày đóng [start_date, end_date].
 *
 * - today: đúng hôm nay -> hôm nay chưa có đơn thì API trả rỗng và biểu đồ
 *   phải hiện 0/empty, không được rơi về một con số cứng nào khác.
 * - week: từ thứ Hai của tuần hiện tại tới hôm nay.
 * - month: từ ngày 1 của tháng hiện tại tới hôm nay.
 */
export function resolveQuickPeriodRange(period: QuickPeriod, now: Date = new Date()): QuickPeriodRange {
  const end = toLocalIsoDate(now);

  if (period === 'today') {
    return { start_date: end, end_date: end };
  }

  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  if (period === 'week') {
    // getDay(): 0 = Chủ nhật. Tuần bắt đầu từ thứ Hai nên Chủ nhật phải lùi 6 ngày.
    const weekday = start.getDay();
    const daysSinceMonday = (weekday + 6) % 7;
    start.setDate(start.getDate() - daysSinceMonday);
  } else {
    start.setDate(1);
  }

  return { start_date: toLocalIsoDate(start), end_date: end };
}
